var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"apiname":"tech-info","headname":"技術情報"}}),_c('div',{staticClass:"card"},[_c('div',{staticClass:"container-fluid"},[_c('h3',{staticClass:"box-title"},[_vm._v("技術情報")]),_c('List',{attrs:{"apiname":"tech-info","editPath":"edit"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c66ce52","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/swan/techInfo/list.vue
// module id = 504
// module chunks = 1